module.exports = __webpack_public_path__ + "img/daily_yorkshire_logo.3fc72697.svg";